<template>
  <div class="wrapper-preview h-100">
    <div class="wrapper-detail w-100">
      <span class="fs-dbb-20"> {{ $t("engine.managePage.pageAddEdit.seo.lblGooglePreview", languageEngine) }} </span>
      <span class="text-hint ml-3">({{ languageUse && languageUse.toUpperCase() }})</span>
      <span class="float-right mode">
        <span class="p-gd-half" :class="{'active' : mode == 'desktop'}"  @click="setMode('desktop')">
          <i class="fal fa-desktop"></i>
        </span>
        <span class="py-gd-half px-gd-1" :class="{'active' : mode == 'mobile'}" @click="setMode('mobile')">
          <i class="fal fa-mobile"></i>
        </span>
      </span>
    </div>
    <div class="wrapper-preview-google mt-gd-1 align-self-center">
      <PreviewGoogleDesktop v-if="mode == 'desktop'" :description="data.description" :title="data.title" :url="url" :typePage="typePage" @setWidth="($e) => $emit('setWidth',$e)" @setWidthDesc="($e) => $emit('setWidthDesc',$e)" />
      <PreviewGoogleMobile v-else :description="data.description" :title="data.title" :url="url" :typePage="typePage" @setWidth="($e) => $emit('setWidth',$e)" @setWidthDesc="($e) => $emit('setWidthDesc',$e)" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PreviewGoogleDesktop from "@components_system/Shared/Tools/PreviewGoogle/PreviewDektop.vue";
import PreviewGoogleMobile from "@components_system/Shared/Tools/PreviewGoogle/PreviewMobile.vue";

export default {
  data() { 
    return {
      mode : 'desktop'
    }
  },
  components: {
    PreviewGoogleDesktop,
    PreviewGoogleMobile,
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
      languageUse: "design/site/languageUse",
    }),
  },
  methods: {
    setMode(mode) {
      this.mode = mode;
      this.$emit('setMode',mode);
    }
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    url : {
      type:String,
      default : ''
    },
    typePage: {
      type:String,
      default : ''
    }
  },
}
</script>

<style lang="scss">
.mode{ 
  cursor: pointer;
  .active {
    background-color: #ebf8fa;
    color: #24bee2;
  }
  span {
    border: 1px solid transparent;
    &:not(.active):hover {
      color: #24bee2;
    }
  }
}
</style>